import React from 'react';
import { useTranslation } from 'react-i18next';

const FuelingContractSimplifiedHeader = () => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // render
  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-end">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className="col-sm-5 col-lg-4">
              {tLabels("fuelingContractSimplifiedHeader.contractNumber")}
            </div>
            <div className="col-sm-7 col-lg-8">
              <div className="row no-gutters align-items-center">
                <div className="col col-sm-7 col-lg-6">
                  {tLabels("fuelingContractSimplifiedHeader.contractDates")}
                </div>  
                <div className="col-auto col-sm-5 col-lg-6">
                  {tLabels("fuelingContractSimplifiedHeader.contractStatus")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FuelingContractSimplifiedHeader;
